<template>
  <div
    v-for="item in props.furnitureItems"
    :key="item.nanoid"
    class="furniture-item"
    :style="containerStyle(item)"
  >
    <furnitureIcon :icon="item.type" :width="item.width" :height="item.length" />
  </div>
</template>

<script setup lang="ts">
import { type CSSProperties } from 'vue'
import type { LocalFurnitureItem } from '@/api/room/types'
import FurnitureIcon from '@/components/furnitureIcon/index.vue'

defineOptions({ name: 'BaseFurnitureView' })

interface Props {
  furnitureItems: LocalFurnitureItem[]
  angle: number
  canvasSize?: number
}

const props = withDefaults(defineProps<Props>(), {
  furnitureItems: () => [],
  angle: 0,
  canvasSize: 500,
})

const containerStyle = (item: LocalFurnitureItem) => {
  const cssObj: CSSProperties = {
    position: 'absolute',
    left: `${item.left}px`,
    top: `${item.top}px`,
    transform: `rotate(${item.rotate}deg)`,
    transformOrigin: 'center center',
    width: `${item.width}px`,
    height: `${item.length}px`,
    pointerEvents: 'none',
    zIndex: 100,
    cursor: 'default',
  }
  return cssObj
}
</script>

<style scoped lang="less">
.furniture-item {
  position: absolute;
  pointer-events: none;
  z-index: 100;
}
</style>
